import React from 'react';
const formatDateVue = (dateString) => {
  const months = ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'];
  const [datePart] = dateString.split('T');
  const [year, month, day] = datePart.split('-');
  const formattedMonth = months[parseInt(month) - 1];
  return `${parseInt(day)} ${formattedMonth}`;
};

const PersonnelList = ({ title, items, refProp }) => {
  return (
    <div className="list-salle personnel-height">
      <div className="nom-salle"><span>{title}</span></div>
      <div className="scroll-container" ref={refProp}>
            {items.length > 0 ? (
              items.map((item, index) => (
                <div key={index} className="details-personnel">
                  <div><span>{item.code}</span> {item.nom} {item.prenom}</div>
                  <div>
                  {formatDateVue(item.dateDebut || item.date_debut)} <span>-</span> {formatDateVue(item.dateFin || item.date_fin)}
                  </div>
                  <div>
                    {item.lieu !== '-' ? (
                      <div>
                        <span>lieu :</span> {item.lieu}
                      </div>
                    ) : null}
                  </div>
                </div>
              ))
            ) : (
              <span></span>
            )}
      </div>
    </div>
  );
};

export default PersonnelList;
